import ClientModal from "custom_modules/WorkOrderNew/CreateWorkOrder/ClientModal";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useCallback } from "react";
import { useDebouncedCallback } from "use-debounce";

import crossIcon from "../../../assets/img/icons/cross_black.svg";
import Plus from "../../../assets/img/icons/plus.svg";
import reorder from "../../../assets/img/reorder.svg";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import ProjectDropdown from "../../../components/CommonFilter/ProjectDropdown";
import DotLoader from "../../../components/DropdownLoader/DropdownLoader";
import CreateProjectDropdown from "../../../components/DropdownStyle/CreateProjectDropdown";
import ButtonTextLoader from "../../../components/Loaders/ButtonTextLoader";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import PricingPlan from "../../../components/PricingPlan";
import Select from "../../../components/ReactSelectDropdown";
import DatePicker from "../../../components/SingleDatePicker/SingleDatePicker";
import InfoTooltip from "../../../components/Tooltip/InfoTooltip";
import {
  ColoredButton,
  PrimaryButton,
  WhiteButton,
} from "../../../styledComponents/buttons";
import {
  CardTitle,
  ColoredText,
  CommonGrid,
  CommonText,
  Container,
  InputField,
  InputLabel,
  InputWithLabelSection,
  PageTitle,
  RedStar,
  TableText,
} from "../../../styledComponents/common";
import {
  BillingQues,
  BillingTooltip,
  BillingTooltipText,
  Cross,
  CrossIcon,
  FormAlert,
  GeneralDetailsInputContainer,
} from "../../../styledComponents/createProject";
import {
  AddItem,
  AddItemContainer,
  CalculationContainer,
  CreateInvoiceItemContainer,
  CreateInvoiceSubTitle,
  ReorderSelectSection,
  SubmitButtonContainer,
  TaxTypeButton,
  ToggleButton,
  ToggleButtonRound,
} from "../../../styledComponents/invoice";
import {
  currenciesWithSymbols,
  currencySymbolMap,
} from "../../../utils/currencies";
import AddClientPopup from "../AddClientPopup";
import SendMailPopup from "../SendMailPopup";

const CreateInvoice = ({
  createInvoiceLoading,
  clearInvoiceLinkedProject,
  selectedOrganization,
  getClientShortList,
  getInvoiceNumber,
  clientShortList,
  createdClientId,
  createdInvoiceInfo,
  invoiceNumber,
  sendInvoiceEmailInfo,
  history,
  linkedProjectState,
  invoiceLinkProject,
  createInvoice,
  createClient,
  profileData,
  sendMailLoading,
  log,
  sendInvoiceEmail,
  isLoading,
  linkProjectLoading,
  createInvoiceUpdateSendLog,
  isInvoiceLimitFull,
  invoiceNumberAlreadyExists,
}) => {
  const [selectClient, setSelectClient] = useState("");

  const [clientOptions, setClientOptions] = useState([]);

  const [invoiceNo, setInvoiceNo] = useState("");

  const [issuedDate, setIssuedDate] = useState(moment(new Date()));

  const [dueDate, setDueDate] = useState(null);

  const [poValue, setPoValue] = useState("");

  const [currency, setCurrency] = useState({
    label: "USD ($) - United States Dollar",
    value: "USD",
  });
  const orgTimeZone = selectedOrganization?.timezone;
  const orgType = selectedOrganization?.type || "operation";

  const [itemArray, setItemArray] = useState([
    {
      type: { value: "service", label: "Service" },
      description: "",
      quantity: 0,
      unitPrice: 0,
      tax1: true,
      tax2: true,
      linkedProject: "",
    },
  ]);

  const [descriptionState, setDescriptionState] = useState({
    index: -1,
    value: "",
  });

  const [quantityState, setQuantityState] = useState({
    index: -1,
    value: 0,
  });

  const [unitPriceState, setUnitPriceState] = useState({
    index: -1,
    value: 0,
  });

  const [focusedIndex, setFocusedIndex] = useState(-1);

  const [tax1, setTax1] = useState({
    percent: true,
    name: "",
    value: 0,
  });

  const [tax2, setTax2] = useState({
    percent: true,
    name: "",
    value: 0,
  });

  const [discount, setDiscount] = useState({
    percent: true,
    value: 0,
  });

  const itemTypeOptions = [
    { value: "service", label: "Service" },
    { value: "product", label: "Product" },
  ];

  const [totalCalc, setTotalCalc] = useState(0);
  const [grandTotalValue, setGrandTotalValue] = useState(0);

  const [saveErrors, setSaveErrors] = useState({});

  const [popupOpen, setPopupOpen] = useState(false);
  const [sendEmailOpen, setSendEmailOpen] = useState(false);
  const [toolTipActive, setToolTipActive] = useState(-1);
  const [sentState, setSentState] = useState(false);
  const [isCreated, setIsCreated] = useState(false);
  const [linkedItemIndex, setLinkedItemIndex] = useState(null);
  const [pricingPopup, setPricingPopup] = useState(false);

  // only for the button loader
  const [isDraft, setIsDraft] = useState(true);

  const myRef = useRef(null);
  const selectRef = useRef(null);

  const executeScroll = () => myRef.current.scrollIntoView();

  useEffect(() => {
    if (selectedOrganization?.id && clientOptions?.length > 0) {
      setTimeout(() => {
        if (selectRef.current) {
          selectRef.current.focus(); // Works in v5
        }
      }, 100);
    }
  }, [clientOptions, selectRef.current, selectedOrganization]);

  useEffect(() => {
    return () => {
      clearInvoiceLinkedProject();
    };
  }, []);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      if (
        selectedOrganization?.plan?.name === "Standard" ||
        selectedOrganization?.plan?.nick_name === "standard-free"
      ) {
        pricingPopupToggle();
      }
      if (
        selectedOrganization.configuration &&
        selectedOrganization.configuration.currency
      ) {
        setCurrency({
          label: `${selectedOrganization.configuration.currency} (${
            currencySymbolMap[selectedOrganization.configuration.currency]
          })`,
          value: selectedOrganization.configuration.currency,
        });
      }
      let payload = {
        organization_id: selectedOrganization.id,
      };
      getClientShortList(payload);
      getInvoiceNumber(payload);
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (clientShortList?.length > 0) {
      let options = [];
      clientShortList
        .filter(item => item.is_active)
        .map(item => {
          // if (createdClientId === item.id) {
          //   setSelectClient({
          //     value: createdClientId,
          //     label: item.name,
          //   });
          // }

          options.push({
            value: item.id,
            label: item.name,
          });
        });
      setClientOptions(options);
    }
  }, [clientShortList]);

  useEffect(() => {
    totalCalculation();
  }, [itemArray]);

  useEffect(() => {
    grandTotalCalculation();
  }, [totalCalc, tax1, tax2, discount]);

  useEffect(() => {
    if (createdClientId && selectedOrganization && selectedOrganization.id) {
      let payload = {
        organization_id: selectedOrganization.id,
      };
      getClientShortList(payload);
    }
  }, [createdClientId]);

  useEffect(() => {
    if (createdInvoiceInfo?.id && isCreated) {
      if (createdInvoiceInfo.saveAndSend) {
        setSendEmailOpen(true);
      } else {
        history.push(`/user/invoice-preview?id=${createdInvoiceInfo.id}`);
      }
    }
  }, [createdInvoiceInfo]);

  useEffect(() => {
    if (invoiceNumber && invoiceNumber.invoice_number) {
      setInvoiceNo(invoiceNumber.invoice_number);
    }
  }, [invoiceNumber]);

  useEffect(() => {
    if (sendInvoiceEmailInfo && sendInvoiceEmailInfo.log_id && sentState) {
      history.push(`/user/invoice-preview?id=${createdInvoiceInfo.id}`);
    }
  }, [sendInvoiceEmailInfo]);

  useEffect(() => {
    let newArr = [...itemArray];
    if (
      linkedProjectState &&
      linkedItemIndex !== null &&
      linkedProjectState.linked_project_id ==
        itemArray[linkedItemIndex].linkedProject.value
    ) {
      newArr[linkedItemIndex].unitPrice = parseFloat(
        linkedProjectState.unit_price,
      ).toFixed(2);
      setItemArray(newArr);
    } else if (!linkedProjectState && linkedItemIndex !== null) {
      newArr[linkedItemIndex].unitPrice = 0;
      setItemArray(newArr);
    }
  }, [linkedProjectState, linkedItemIndex]);

  useEffect(() => {
    if (isInvoiceLimitFull && isCreated) {
      setPricingPopup(true);
    }
  }, [isInvoiceLimitFull]);
  useEffect(() => {
    if (invoiceNumberAlreadyExists) {
      console.log(
        "🚀 ~ file: CreateInvoice.jsx:305 ~ useEffect ~ invoiceNumberAlreadyExists:",
        invoiceNumberAlreadyExists,
      );
      document.getElementById("invoiceNumber").focus();
    }
  }, [invoiceNumberAlreadyExists]);

  const onClientChange = e => {
    let errors = { ...saveErrors };
    delete errors["client"];
    setSaveErrors(errors);
    setSelectClient(e);
  };

  const onInvoiceNumberChange = e => {
    setInvoiceNo(e.target.value);
  };

  const onIssuedDateChange = date => {
    setIssuedDate(date);
  };

  const onDueDateChange = date => {
    setDueDate(date);
  };

  const onPoValueChange = e => {
    setPoValue(e.target.value);
  };

  const onCurrencyChange = e => {
    setCurrency(e);
  };

  const onItemTypeChange = (e, index) => {
    let newArr = [...itemArray];
    newArr[index].type = e;
    setItemArray(newArr);
  };

  const onItemDescFocus = index => {
    setSaveErrors({});
    setDescriptionState({ index: index, value: itemArray[index].description });
  };

  const onItemDescChange = (e, index) => {
    let errors = { ...saveErrors };
    delete errors[`itemDescription_${index}`];
    setSaveErrors(errors);
    setDescriptionState({
      ...descriptionState,
      value: e.target.value,
    });
  };

  const onItemDescBlur = index => {
    let newArr = [...itemArray];
    newArr[index].description = descriptionState.value;
    setItemArray(newArr);
    setDescriptionState({
      active: -1,
      value: "",
    });
  };

  const onItemQuantityChange = (e, index) => {
    let errors = { ...saveErrors };
    delete errors[`itemQuantity_${index}`];
    setSaveErrors(errors);

    let newArr = [...itemArray];
    newArr[index].quantity = e.target.value;
    setItemArray(newArr);
  };

  const onItemUnitPriceChange = (e, index) => {
    let errors = { ...saveErrors };
    delete errors[`itemUnitPrice_${index}`];
    setSaveErrors(errors);

    let newArr = [...itemArray];
    newArr[index].unitPrice = e.target.value;
    setItemArray(newArr);
  };

  const onItemTax1Change = index => {
    let newArr = [...itemArray];
    newArr[index].tax1 = !newArr[index].tax1;
    setItemArray(newArr);
    grandTotalCalculation();
  };

  const onItemTax2Change = index => {
    let newArr = [...itemArray];
    newArr[index].tax2 = !newArr[index].tax2;
    setItemArray(newArr);
    grandTotalCalculation();
  };

  const onItemLinkedProjectChange = (e, index) => {
    let newArr = [...itemArray];
    newArr[index].linkedProject = e;
    newArr[index].description = e.label;
    newArr[index].quantity = 1;
    setItemArray(newArr);
    setLinkedItemIndex(index);

    if (selectedOrganization && selectedOrganization.id) {
      invoiceLinkProject({
        organization_id: selectedOrganization.id,
        linked_project_id: e.value,
      });
    }
  };

  const addItemToarray = () => {
    let newArray = [...itemArray];
    let newItem = {
      type: { value: "service", label: "Service" },
      description: "",
      quantity: 0,
      unitPrice: 0,
      tax1: true,
      tax2: true,
      linkedProject: "",
    };
    newArray.push(newItem);
    setItemArray(newArray);
    setSaveErrors({});
  };

  const handleDeleteItem = index => {
    let newArray = [...itemArray];
    newArray.splice(index, 1);
    setItemArray(newArray);
  };

  const onTax1NameChange = e => {
    setTax1({ ...tax1, name: e.target.value });
  };

  const onTax1ValueChange = e => {
    let errors = { ...saveErrors };
    delete errors[`tax1Value`];
    setSaveErrors(errors);

    setTax1({ ...tax1, value: e.target.value });
  };

  const toggleTax1CalcType = value => {
    setTax1({
      ...tax1,
      percent: value,
    });
  };

  const onTax2NameChange = e => {
    setTax2({ ...tax2, name: e.target.value });
  };

  const onTax2ValueChange = e => {
    let errors = { ...saveErrors };
    delete errors[`tax2Value`];
    setSaveErrors(errors);

    setTax2({ ...tax2, value: e.target.value });
  };

  const toggleTax2CalcType = value => {
    setTax2({
      ...tax2,
      percent: value,
    });
  };

  const onDiscountValueChange = e => {
    let errors = { ...saveErrors };
    delete errors[`discountValue`];
    delete errors[`discountFixed`];
    setSaveErrors(errors);

    setDiscount({ ...discount, value: e.target.value });
  };

  const toggleDiscountCalcType = value => {
    setDiscount({
      ...discount,
      percent: value,
    });
  };

  const totalCalculation = () => {
    if (itemArray && itemArray.length) {
      let total = 0;
      itemArray.map(item => {
        total += item.quantity * item.unitPrice;
      });
      setTotalCalc(total.toFixed(2));
    }
  };

  const grandTotalCalculation = () => {
    const calcaulateTaxDiscount = (object, cost) => {
      if (object.percent) {
        return (object.value * cost) / 100;
      } else if (object.value) {
        return object.value;
      } else {
        return 0;
      }
    };

    if (itemArray && itemArray.length) {
      let totalTax = 0;
      itemArray.map((item, index) => {
        let itemCost = item.quantity * item.unitPrice;
        if (item.tax1) {
          totalTax += parseFloat(calcaulateTaxDiscount(tax1, itemCost));
        }
        if (item.tax2) {
          totalTax += parseFloat(calcaulateTaxDiscount(tax2, itemCost));
        }
      });

      let grandTotal =
        parseFloat(totalCalc) +
        totalTax -
        parseFloat(calcaulateTaxDiscount(discount, totalCalc));
      setGrandTotalValue(grandTotal.toFixed(2));
    }
  };

  const popupToggle = () => {
    setPopupOpen(!popupOpen);
  };
  const sendEmailToggle = () => {
    setSendEmailOpen(!sendEmailOpen);
  };

  const onSend = () => {
    setSentState(true);
  };

  const pricingPopupToggle = () => {
    setPricingPopup(!pricingPopup);
  };

  const checkError = () => {
    let formIsValid = true;
    let saveErrors = {};
    if (selectClient === "") {
      saveErrors["client"] = "Customer can not be empty";
      formIsValid = false;
      executeScroll();
    }

    if (itemArray && itemArray.length > 0) {
      itemArray.forEach((item, index) => {
        if (item.description && item.description.length > 512) {
          saveErrors[`itemDescription_${index}`] =
            "Item Description can have maximum 512 characters";
          formIsValid = false;
        }
        if (parseFloat(item.quantity) < 1) {
          saveErrors[`itemQuantity_${index}`] =
            "Item Quantity can't be less than 1.";
          formIsValid = false;
        }
        if (parseFloat(item.unitPrice) < 0) {
          saveErrors[`itemUnitPrice_${index}`] =
            "Item unit-price can't be negative.";
          formIsValid = false;
        }
      });
    } else {
      saveErrors["noItem"] = "You have to add at least one item";
      formIsValid = false;
    }

    if (tax1 && parseFloat(tax1.value) < 0) {
      saveErrors["tax1Value"] = "Tax 1 value can't be negative.";
      formIsValid = false;
    }
    if (tax2 && parseFloat(tax2.value) < 0) {
      saveErrors["tax2Value"] = "Tax 2 value can't be negative.";
      formIsValid = false;
    }

    if (discount && discount.percent && parseFloat(discount.value) > 100) {
      saveErrors["discountValue"] = "Discount can't be greater than 100%.";
      formIsValid = false;
    } else if (
      discount &&
      !discount.percent &&
      parseFloat(discount.value) > parseFloat(totalCalc)
    ) {
      saveErrors["discountFixed"] =
        "Discount can't be greater than total amount";
      formIsValid = false;
    }

    setSaveErrors(saveErrors);
    return formIsValid;
  };

  const handleSave = useCallback(
    saveAndSend => {
      if (checkError()) {
        if (selectedOrganization && selectedOrganization.id) {
          let newItems = [];

          if (itemArray && itemArray.length > 0) {
            itemArray.forEach(item => {
              if (item.quantity > 0) {
                newItems.push({
                  type: item.type.value,
                  description: item.description,
                  linked_task_id: item.linkedProject.value,
                  unit_price: item.unitPrice,
                  quantity: item.quantity,
                  tax1: item.tax1,
                  tax2: item.tax2,
                });
              }
            });
          }

          const payload = {
            organization_id: selectedOrganization.id,
            client_id: selectClient.value,
            invoice_number:
              invoiceNo === ""
                ? `${selectedOrganization.name.substring(
                    0,
                    selectedOrganization.name.indexOf(" "),
                  )}_${Math.ceil(Math.random() * 10000)}`
                : invoiceNo,

            issued_date: issuedDate.format("YYYY-MM-DD"),
            due_date: dueDate !== null ? dueDate.format("YYYY-MM-DD") : dueDate,
            po_number: poValue === "" ? null : poValue,
            currency: (currency && currency.value) || "USD",
            tax1: {
              type: tax1.percent ? "percent" : "fixed",
              name: tax1.name === "" ? "tax 1" : tax1.name,
              [tax1.percent ? "percent_amount" : "fixed_amount"]:
                tax1.value || 0,
            },
            tax2: {
              type: tax2.percent ? "percent" : "fixed",
              name: tax2.name === "" ? "tax 2" : tax2.name,
              [tax2.percent ? "percent_amount" : "fixed_amount"]:
                tax2.value || 0,
            },
            discount: {
              type: discount.percent ? "percent" : "fixed",
              [discount.percent ? "percent_amount" : "fixed_amount"]:
                discount.value || 0,
            },
            items: newItems,
            saveAndSend,
          };

          createInvoice(payload);
          setIsCreated(true);
          if (saveAndSend) {
            setIsDraft(false);
          }
        }
      }
    },
    [
      checkError,
      selectedOrganization,
      itemArray,
      selectClient,
      invoiceNo,
      issuedDate,
      dueDate,
      poValue,
      currency,
      tax1,
      tax2,
      discount,
      createInvoice,
      sendEmailOpen,
    ],
  );

  const cancelFunction = () => {
    history.push("/user/invoices");
  };

  return (
    <div className="content">
      <PricingPlan
        isOpen={pricingPopup}
        toggle={pricingPopupToggle}
        popupText="You have reached the limit of creating invoices."
        popupTitle="Upgrade to Elite to create unlimited invoices"
        history={history}
        backRoute="/user/dashboard"
        onlyElite
      />
      {/* <PageTitle>Invoices</PageTitle> */}
      <div
        style={{
          display: `grid`,
          gridTemplateColumns: `auto`,
          justifyContent: `start`,
          marginTop: "12px",
        }}
      >
        <BackButtonComponent
          onClick={() => history.push("/user/invoices")}
          subTitle="Back to all invoices"
        />
      </div>
      <CreateInvoiceSubTitle>
        Detail information of your Invoice
      </CreateInvoiceSubTitle>

      {selectedOrganization && selectedOrganization.id && (
        <ClientModal
          isOpen={popupOpen}
          toggle={popupToggle}
          selectedOrganization={selectedOrganization}
          createClient={createClient}
          createdClientId={createdClientId}
          // createdClientInfo={createdClientInfo}
          setSelectedClient={setSelectClient}
        />
      )}

      {selectedOrganization &&
        selectedOrganization.id &&
        createdInvoiceInfo &&
        createdInvoiceInfo.id &&
        profileData && (
          <SendMailPopup
            isOpen={sendEmailOpen}
            isLoading={sendMailLoading}
            toggle={sendEmailToggle}
            organization_id={selectedOrganization.id}
            organization_name={selectedOrganization.name}
            invoice_id={createdInvoiceInfo.id}
            senderName={profileData.first_name}
            invoiceNumber={createdInvoiceInfo.invoice_number}
            issuedDate={createdInvoiceInfo.issued_date}
            dueDate={createdInvoiceInfo.due_date}
            email={createdInvoiceInfo.client.email}
            log={log}
            createInvoiceUpdateSendLog={createInvoiceUpdateSendLog}
            sendInvoiceEmail={sendInvoiceEmail}
            onSend={onSend}
            history={history}
            createInvoice
          />
        )}

      <Container marginTop="12px" padding="30px 0" ref={myRef}>
        {isLoading ? (
          <ComponentCircleLoader />
        ) : (
          <>
            <CardTitle style={{ paddingLeft: "30px" }} fontSize="16px">
              {invoiceNo}
            </CardTitle>
            <CommonText margin="10px 30px 15px">
              {selectedOrganization &&
                selectedOrganization.id &&
                selectedOrganization.name}
            </CommonText>
            <GeneralDetailsInputContainer>
              <InputWithLabelSection>
                <CommonGrid>
                  <InputLabel>
                    Customer <RedStar>*</RedStar>
                  </InputLabel>
                  <AddItem
                    columns="18px auto"
                    gap="5px"
                    onClick={() => popupToggle()}
                  >
                    <img src={Plus} alt="plus" />
                    <ColoredText
                      fontSize="14px"
                      primary
                      hover
                      borderRadius="32px"
                    >
                      Add Customer
                    </ColoredText>
                  </AddItem>
                </CommonGrid>
                <Select
                  key={`select-${clientOptions?.length}-${selectedOrganization?.id}`}
                  isSearchable
                  // inputRef={input => console.log("InputRef:", input)}
                  // ref={selectRef}
                  value={selectClient}
                  options={clientOptions}
                  placeholder="Select customer..."
                  onChange={e => {
                    onClientChange(e);
                  }}
                  styles={CreateProjectDropdown({
                    error: saveErrors["client"],
                  })}
                />
                {saveErrors && saveErrors["client"] && (
                  <FormAlert>{saveErrors["client"]}</FormAlert>
                )}
              </InputWithLabelSection>
              <InputWithLabelSection>
                <InfoTooltip
                  redStar
                  padding="0"
                  label
                  fontSize="13px"
                  fontWeight="500"
                  top="-75px"
                  mainText="Invoice Number "
                  toolTipText="The invoice number is a unique number. You can customize this as you need."
                />
                <InputField
                  type="text"
                  placeholder="Type invoice number"
                  value={invoiceNo}
                  id="invoiceNumber"
                  onChange={e => onInvoiceNumberChange(e)}
                />
              </InputWithLabelSection>
              <InputWithLabelSection>
                <InputLabel>PO Number</InputLabel>
                <InputField
                  type="text"
                  placeholder="Type..."
                  value={poValue}
                  onChange={e => onPoValueChange(e)}
                />
              </InputWithLabelSection>
              <InputWithLabelSection>
                <InputLabel>
                  Issued Date <RedStar>*</RedStar>
                </InputLabel>
                <DatePicker
                  id="createIssuedDate"
                  width="100%"
                  date={issuedDate}
                  onDateChange={onIssuedDateChange}
                  placeholder={"Select issued date"}
                  allowPreviousDates
                />
              </InputWithLabelSection>
              <InputWithLabelSection>
                <InputLabel>Due Date</InputLabel>
                <DatePicker
                  id="createDueDate"
                  width="100%"
                  date={dueDate}
                  onDateChange={onDueDateChange}
                  placeholder={"Select due date"}
                  allowPreviousDates
                />
              </InputWithLabelSection>
              <InputWithLabelSection>
                <InputLabel>Currency</InputLabel>
                <Select
                  isSearchable
                  value={currency}
                  options={currenciesWithSymbols}
                  placeholder="Select Currency..."
                  onChange={e => {
                    onCurrencyChange(e);
                  }}
                  styles={CreateProjectDropdown({
                    error: saveErrors["currency"],
                  })}
                />
                {saveErrors && saveErrors["currency"] && (
                  <FormAlert>{saveErrors["currency"]}</FormAlert>
                )}
              </InputWithLabelSection>
            </GeneralDetailsInputContainer>

            <CreateInvoiceItemContainer heading>
              <ReorderSelectSection heading>
                <div></div>
                <TableText>No.</TableText>
              </ReorderSelectSection>
              <TableText>Item Type</TableText>
              <TableText>Description</TableText>
              <TableText>Quantity</TableText>
              <TableText>Unit Price</TableText>
              <TableText>Amount</TableText>
              <TableText>Tax 1</TableText>
              <TableText>Tax 2</TableText>
              <div></div>
            </CreateInvoiceItemContainer>
            {itemArray?.length > 0 &&
              itemArray.map((item, index) => (
                <React.Fragment key={index}>
                  <CreateInvoiceItemContainer>
                    <ReorderSelectSection heading>
                      <div>
                        <img src={reorder} />
                      </div>
                      <CommonText> {index + 1} </CommonText>
                    </ReorderSelectSection>
                    <Select
                      isSearchable
                      value={item.type}
                      options={itemTypeOptions}
                      placeholder="Select type..."
                      onChange={e => {
                        onItemTypeChange(e, index);
                      }}
                      indicatorIconSize="16px"
                      styles={CreateProjectDropdown({ height: "34px" })}
                    />

                    {item.linkedProject == "" ? (
                      <React.Fragment>
                        <InputField
                          height="34px"
                          type="text"
                          placeholder="Type description"
                          value={
                            descriptionState.index === index
                              ? descriptionState.value
                              : item.description
                          }
                          onFocus={() => onItemDescFocus(index)}
                          onChange={e => onItemDescChange(e, index)}
                          onBlur={() => onItemDescBlur(index)}
                        />
                        <InputField
                          height="34px"
                          type="number"
                          min="0"
                          value={item.quantity}
                          onChange={e => onItemQuantityChange(e, index)}
                          onWheel={e => e.target.blur()}
                          style={
                            saveErrors &&
                            saveErrors[`itemQuantity_${index}`] && {
                              border: `1px solid #fe5969`,
                              backgroundColor: `rgba(252, 87, 104, 0.05)`,
                            }
                          }
                        />
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <CommonText> {item.description} </CommonText>
                        <CommonText> {item.quantity} </CommonText>
                      </React.Fragment>
                    )}
                    <InputField
                      height="34px"
                      type="number"
                      min="0"
                      value={item.unitPrice}
                      onChange={e => onItemUnitPriceChange(e, index)}
                      onWheel={e => e.target.blur()}
                      style={
                        saveErrors &&
                        saveErrors[`itemUnitPrice_${index}`] && {
                          border: `1px solid #fe5969`,
                          backgroundColor: `rgba(252, 87, 104, 0.05)`,
                        }
                      }
                    />
                    {(quantityState.active || unitPriceState.active) &&
                    focusedIndex === index ? (
                      <CommonText style={{ opacity: `0.4` }}>
                        {`${
                          currency &&
                          currency.value &&
                          currencySymbolMap[currency.value]
                        } ${(item.quantity * item.unitPrice).toFixed(2)}`}
                      </CommonText>
                    ) : (
                      <CommonText>
                        {`${
                          currency &&
                          currency.value &&
                          currencySymbolMap[currency.value]
                        } ${(item.quantity * item.unitPrice).toFixed(2)}`}
                      </CommonText>
                    )}
                    <ToggleButton
                      onClick={() => onItemTax1Change(index)}
                      active={item.tax1}
                    >
                      <ToggleButtonRound active={item.tax1} />
                    </ToggleButton>
                    <ToggleButton
                      onClick={() => onItemTax2Change(index)}
                      active={item.tax2}
                    >
                      <ToggleButtonRound active={item.tax2} />
                    </ToggleButton>
                    <Cross onClick={() => handleDeleteItem(index)} size="26px">
                      <CrossIcon src={crossIcon} alt="" size="18px" />
                    </Cross>
                  </CreateInvoiceItemContainer>
                  {saveErrors && saveErrors[`itemDescription_${index}`] && (
                    <>
                      <CreateInvoiceItemContainer
                        style={{ padding: `0 30px 10px 30px` }}
                      >
                        <div style={{ gridColumn: `3 / span 4` }}>
                          <FormAlert>
                            {saveErrors[`itemDescription_${index}`]}
                          </FormAlert>
                        </div>
                      </CreateInvoiceItemContainer>
                    </>
                  )}
                  <CreateInvoiceItemContainer
                    style={{ padding: `0 30px 10px 30px` }}
                    marginTop="10px"
                  >
                    <CommonGrid
                      justifyContent="start"
                      alignItems="center"
                      columns="auto 200px auto"
                      alignItem="center"
                      style={{ gridColumn: `3 / span 4` }}
                    >
                      <CommonText fontSize="13px">Linked Job</CommonText>
                      {linkProjectLoading &&
                      linkedItemIndex !== null &&
                      linkedItemIndex === index ? (
                        <DotLoader loading />
                      ) : (
                        <ProjectDropdown
                          selectedOrganization={selectedOrganization}
                          selectedProject={item.linkedProject}
                          selectProject={e =>
                            onItemLinkedProjectChange(e, index)
                          }
                          selectedMember={selectClient}
                          indicatorIconSize="18px"
                          style={CreateProjectDropdown({ height: "36px" })}
                        />
                      )}
                      <BillingQues
                        onMouseEnter={() => setToolTipActive(index)}
                        onMouseLeave={() => setToolTipActive(-1)}
                      >
                        ?
                        {toolTipActive === index && (
                          <BillingTooltip top="-75px">
                            <BillingTooltipText>
                              The invoice can be billed for specific job. You
                              can see this details in the job analysis page.
                            </BillingTooltipText>
                          </BillingTooltip>
                        )}
                      </BillingQues>
                    </CommonGrid>
                  </CreateInvoiceItemContainer>
                </React.Fragment>
              ))}
            <AddItemContainer>
              <AddItem onClick={() => addItemToarray()}>
                <img src={Plus} alt="plus" />
                <ColoredText fontSize="14px" primary hover>
                  Add More items
                </ColoredText>
              </AddItem>
              {saveErrors && saveErrors["noItem"] && (
                <FormAlert>{saveErrors["noItem"]}</FormAlert>
              )}
            </AddItemContainer>

            <CalculationContainer style={{ margin: `20px 0` }}>
              <div />
              <TableText>Total</TableText>
              <ColoredText primary semibold>
                {" "}
                {totalCalc}{" "}
              </ColoredText>
            </CalculationContainer>
            <CalculationContainer style={{ padding: `0 10px` }}>
              <div />
              <InputLabel>Tax Name</InputLabel>
              <InputLabel style={{ gridColumn: `4 / span 3` }}>
                In percent or fixed amount?
              </InputLabel>
            </CalculationContainer>
            <CalculationContainer>
              <CommonText>Tax 1</CommonText>
              <InputField
                type="text"
                placeholder="Type name"
                value={tax1.name}
                onChange={e => onTax1NameChange(e)}
              />
              <InputField
                type="number"
                min="0"
                value={tax1.value}
                onChange={e => onTax1ValueChange(e)}
                onWheel={e => e.target.blur()}
                style={
                  saveErrors &&
                  saveErrors["tax1Value"] && {
                    border: `1px solid #fe5969`,
                    backgroundColor: `rgba(252, 87, 104, 0.05)`,
                  }
                }
              />
              <TaxTypeButton
                percent
                active={tax1.percent}
                onClick={() => toggleTax1CalcType(true)}
              >
                %
              </TaxTypeButton>
              {currency && currency.value && (
                <TaxTypeButton
                  fontSize="12px"
                  active={!tax1.percent}
                  onClick={() => toggleTax1CalcType(false)}
                >
                  {currencySymbolMap[currency.value]}
                </TaxTypeButton>
              )}
              <div />
              <CommonText>Tax 2</CommonText>
              <InputField
                type="text"
                placeholder="Type name"
                value={tax2.name}
                onChange={e => onTax2NameChange(e)}
              />
              <InputField
                type="number"
                min="0"
                value={tax2.value}
                onChange={e => onTax2ValueChange(e)}
                onWheel={e => e.target.blur()}
                style={
                  saveErrors &&
                  saveErrors["tax2Value"] && {
                    border: `1px solid #fe5969`,
                    backgroundColor: `rgba(252, 87, 104, 0.05)`,
                  }
                }
              />
              <TaxTypeButton
                percent
                active={tax2.percent}
                onClick={() => toggleTax2CalcType(true)}
              >
                %
              </TaxTypeButton>
              {currency && currency.value && (
                <TaxTypeButton
                  fontSize="12px"
                  active={!tax2.percent}
                  onClick={() => toggleTax2CalcType(false)}
                >
                  {currencySymbolMap[currency.value]}
                </TaxTypeButton>
              )}
              <div />
              <div />
              <CommonText>Discount</CommonText>
              <InputField
                type="number"
                min="0"
                value={discount.value}
                onChange={e => onDiscountValueChange(e)}
                onWheel={e => e.target.blur()}
                style={
                  saveErrors &&
                  saveErrors["discountValue"] && {
                    border: `1px solid #fe5969`,
                    backgroundColor: `rgba(252, 87, 104, 0.05)`,
                  }
                }
              />
              <TaxTypeButton
                percent
                active={discount.percent}
                onClick={() => toggleDiscountCalcType(true)}
              >
                %
              </TaxTypeButton>
              {currency && currency.value && (
                <TaxTypeButton
                  fontSize="12px"
                  active={!discount.percent}
                  onClick={() => toggleDiscountCalcType(false)}
                >
                  {currencySymbolMap[currency.value]}
                </TaxTypeButton>
              )}
              {saveErrors && saveErrors["discountFixed"] ? (
                <FormAlert>{saveErrors["discountFixed"]}</FormAlert>
              ) : (
                <div />
              )}
            </CalculationContainer>
            <CalculationContainer grand>
              <div />
              <TableText>Grand Total</TableText>
              <ColoredText primary semibold>
                {currency.value} ({currencySymbolMap[currency.value]}){" "}
                {grandTotalValue}
              </ColoredText>
            </CalculationContainer>
            <CalculationContainer style={{ marginTop: `30px` }} padding="0">
              <SubmitButtonContainer>
                <WhiteButton type="cancel" onClick={() => cancelFunction()}>
                  Cancel
                </WhiteButton>
                <ColoredButton
                  type="grayMedium"
                  padding={createInvoiceLoading && isDraft && "0 30px"}
                  onClick={() => handleSave(false)}
                  disabled={createInvoiceLoading}
                >
                  {createInvoiceLoading && isDraft ? (
                    <ButtonTextLoader loadingText="Saving" fontSize="13px" />
                  ) : (
                    "Save As Draft"
                  )}
                </ColoredButton>
                <PrimaryButton
                  padding={createInvoiceLoading && !isDraft && "0 30px"}
                  onClick={() => handleSave(true)}
                  disabled={createInvoiceLoading}
                >
                  {createInvoiceLoading && !isDraft ? (
                    <ButtonTextLoader loadingText="Saving" fontSize="13px" />
                  ) : (
                    "Save & Send"
                  )}
                </PrimaryButton>
              </SubmitButtonContainer>
            </CalculationContainer>
          </>
        )}
      </Container>
    </div>
  );
};

export default CreateInvoice;
